import { Injectable, ViewChild } from "@angular/core";
import { Component, OnInit, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { BehaviorSubject, Observable } from "rxjs";

import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { NzUploadChangeParam } from "ng-zorro-antd/upload";

import { HttpClient, HttpHeaders } from "@angular/common/http";

import { User } from "@app/_models";
import { Files } from "@app/_models";
import { UserService, AuthenticationService } from "@app/_services";
import { ApiBackendService } from "@app/_services/api-backend.service";

@Component({
  selector: "app-upload",
  templateUrl: "upload.component.html",
  styleUrls: ["upload.component.css"],
})
@Injectable({ providedIn: "root" })
export class UploadComponent implements OnInit {
  users: User[];
  apiUrl = null;
  bodyData = null;
  loading = false;
  loadingPage = true;
  path = null;
  file = null;
  userCreated = null;
  isSpinning = false;
  files: Observable<Files[]>;
  error = null;
  errorMessage = null;
  currentUser = JSON.parse(localStorage.getItem("currentUser"));
  filesList: any[] = [];
  progress = null;
  uploadText = "Încarcă balanţa sintetică în Excel şi obţine în 5 secunde povestea cifrelor tale.";
  isVisibleModal = false;
  isConfirmLoading = false;
  fileDate = null;
  userCredit = null;
  unlimitedSubscription: boolean = false;
  tranzactionType: String;
  public mobilpayData: any = [];
  fileTypeError = 0;
  alertTxt = "Te rog asigura-te ca:<br><br>- fișierul este in format Excel<br>- toate informațiile balantei sunt intr-o singura pagină<br>- balanta ta este una sintetica<br><br>Reîncarca apoi încă o data fișierul.";
  // uploadPercent: Observable<number>;
  // downloadUrl = Observable<string>;
  fullMonths = {
    1: "Ianuarie",
    2: "Februarie",
    3: "Martie",
    4: "Aprilie",
    5: "Mai",
    6: "Iunie",
    7: "Iulie",
    8: "August",
    9: "Septembrie",
    10: "Octombrie",
    11: "Noiembrie",
    12: "Decembrie",
  };

  @ViewChild("form") form;
  constructor(private userService: UserService, private storage: AngularFireStorage, private route: ActivatedRoute, private http: HttpClient, private router: Router, private authenticationService: AuthenticationService, private modal: NzModalService, private msg: NzMessageService, private viewContainerRef: ViewContainerRef, public apiBackendService: ApiBackendService) {
    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      // this.router.navigate(['/authentification']);
    }
    this.apiUrl = this.authenticationService.apiUrl;
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    // this.loading = true;
    // this.userService.getAll().pipe(first()).subscribe(users => {
    //     this.loading = false;
    //     this.users = users;
    // });

    this.getUser()
      .pipe()
      .subscribe((res) => {
        // console.log(res.body['credit']);
        this.userCredit = res.body["credit"];
        this.unlimitedSubscription = res.body["unlimitedSubscription"];
        this.loadingPage = false;
        if (this.userCredit <= 0 && !this.unlimitedSubscription) {
          this.router.navigate(["/pay"]);
        }
      });
  }

  getUser() {
    return this.http.get<User[]>(this.apiUrl + "/user/" + this.currentUser.id, {
      observe: "response",
    });
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  uploadFile(event) {
    console.log("file upload", event[0]);
    const file = event[0];
    if (file.type == "application/vnd.ms-excel" || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.progress = 1;
      const timeStamp = Math.floor(Date.now() / 1000);
      const filePath = timeStamp + "_" + file.name;
      this.uploadText = "Uploading... " + file.name;
      const task = this.storage.upload(filePath, file);
      const month = this.fileDate.getMonth() + 1;
      const year = this.fileDate.getFullYear();

      this.bodyData = {
        path: "/",
        files: filePath,
        userCreated: this.currentUser.id,
        month: month,
        year: year,
      };
      localStorage.setItem("fileMonthYear", this.fullMonths[month] + " " + year);
      localStorage.setItem("fileMonth", this.fullMonths[month]);
      localStorage.setItem("fileYear", year);

      setTimeout(() => {
        const progressInterval = setInterval(() => {
          if (file.progress === 100) {
            clearInterval(progressInterval);
            this.uploadText = "File uploaded!";
            this.isSpinning = true;
            this.sendFile(this.bodyData);
          } else {
            file.progress += 5;
            this.progress = file.progress;
          }
        }, 200);
      }, 1000);
    } else {
      this.fileTypeError = 1;
    }
  }

  sendFile(bodyData) {
    this.setFile(this.bodyData)
      .pipe()
      .subscribe(
        (res) => {
          if (res["balanceProcessError"] == 0) {
            this.isSpinning = false;
            // this.uploadText += ' ' + res['balanceProcessMessage'];
            if (res["fileId"]) {
              localStorage.setItem("fileId", res["fileId"].toString());
            }
            this.router.navigate(["/file/" + res["IDBalanceProcessed"]]);
          } else {
            // this.error = res['balanceProcessError'];
            // this.errorMessage = res['balanceProcessMessage'];
            //                'Ooops, balanta ta nu a putut fi procesata. Nu-ti face griji, oricare ar fi motivul, il rezolvam. Te anuntam printr-un email cand poti intra in aplicatie pentru vizualizarea raportului.'
            this.modal.warning({
              nzTitle: "Atenţie!",
              nzContent: res["errorMessageUser"],
              nzOkText: "Inchide",
              nzOnOk: () => {
                this.router.navigate(["/files"]);
              },
              // nzContent: res['balanceProcessMessage'],
              // nzOkText: 'Ok, afişează rezultatele',
              // nzOnOk: () => {
              //   this.router.navigate(['/file/' + res['IDBalanceProcessed']]);
              // },
            });
            this.isSpinning = false;
          }
        },
        (err) => {
          this.error = 1;
          this.errorMessage = err;
          this.isSpinning = false;
        }
      );
  }

  setFile(bodyData) {
    return this.http.post<Files[]>(this.apiUrl + "/files", this.bodyData);
  }

  prepareFilesList(filesList: Array<any>) {
    for (const item of filesList) {
      item.progress = 0;
      this.filesList.push(item);
    }
    this.fileDate = new Date();
    this.isVisibleModal = true;
    // this.uploadFile(this.filesList);;
  }

  onValueChange(value: Date): void {
    console.log(`Current value: ${value}`);
    this.fileDate = value;
  }

  onPanelChange(change: { date: Date; mode: string }): void {
    console.log(`Current value: ${change.date}`);
    console.log(`Current mode: ${change.mode}`);
  }

  handleOk(): void {
    this.isConfirmLoading = true;
    this.isVisibleModal = false;
    this.uploadFile(this.filesList);
  }

  handleCancel(): void {
    this.isVisibleModal = false;
  }

  tranzactionTypeChanged() {
    console.log("tranzaction changed", this.tranzactionType);
    this.apiBackendService
      .getMobilPayData(this.tranzactionType)
      .pipe()
      .subscribe((res) => {
        this.mobilpayData = res.body;
        setTimeout(() => {
          this.form.nativeElement.submit();
        });
        // this.payLoading = false;
        // this.isVisibleModal = true;
        // console.log(this.mobilpayData);
      });
  }
}
